export default "__VITE_PUBLIC_ASSET__f68e5421__"